import { render } from "./ChangePassword.vue?vue&type=template&id=b999d752&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=b999d752&lang=scss"
import "./ChangePassword.vue?vue&type=style&index=1&id=b999d752&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b999d752"]])

export default __exports__